// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jua&family=Noto+Sans+KR:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * QR프린터관리 스타일 - 가로 태블릿용
 */

.pm-page {
  height: 100dvh;
  background: linear-gradient(135deg, #ECEFF1 0%, #CFD8DC 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pm-page button, .pm-page input { min-height: auto; }

.pm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: rgba(255,255,255,0.85);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0,0,0,0.06);
  flex-shrink: 0;
}

.pm-header .btn-back {
  background: none;
  border: 2px solid #78909C;
  color: #546E7A;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.pm-header .btn-back:active {
  background: #ECEFF1;
}

.pm-header-center {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.pm-header h1 {
  font-family: 'Jua', sans-serif;
  font-size: 20px;
  color: #37474F;
  margin: 0;
}

.pm-header-spacer { width: 72px; }

.pm-content {
  flex: 1 1;
  padding: 12px 16px;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-content: flex-start;
}

.pm-loading, .pm-error, .pm-empty {
  width: 100%;
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: #666;
}

.pm-error { color: #C62828; }

.pm-store-group {
  width: 100%;
}

.pm-store-name {
  font-family: 'Jua', sans-serif;
  font-size: 18px;
  color: #37474F;
  margin: 0 0 8px;
}

.pm-printer-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.pm-printer-card {
  background: #fff;
  border-radius: 14px;
  padding: 14px 16px;
  width: calc(50% - 6px);
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  border-left: 4px solid #2E7D32;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pm-printer-card.pm-status-warning { border-left-color: #F57C00; }
.pm-printer-card.pm-status-critical { border-left-color: #C62828; }
.pm-printer-card.pm-status-empty { border-left-color: #B71C1C; background: #FFF5F5; }

.pm-printer-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pm-printer-name {
  font-family: 'Jua', sans-serif;
  font-size: 16px;
  color: #333;
}

.pm-disabled-badge {
  margin-left: 6px;
  padding: 2px 8px;
  background: #EEE;
  color: #999;
  border-radius: 8px;
  font-size: 11px;
}

.pm-printer-status {
  font-size: 13px;
  font-weight: 700;
}

.pm-paper-bar-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pm-paper-bar {
  width: 100%;
  height: 10px;
  background: #E0E0E0;
  border-radius: 5px;
  overflow: hidden;
}

.pm-paper-bar-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 0.5s ease;
}

.pm-paper-numbers {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.pm-remaining { font-weight: 700; }
.pm-total { color: #999; }

.pm-paper-detail {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #888;
}

.pm-reset-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.pm-reset-input {
  width: 70px;
  padding: 6px 8px;
  border: 2px solid #E0E0E0;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
}

.pm-reset-input:focus {
  border-color: #2E7D32;
  outline: none;
}

.pm-reset-btn {
  flex: 1 1;
  padding: 8px 12px;
  background: linear-gradient(135deg, #43A047, #2E7D32);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s;
}

.pm-reset-btn:active { transform: scale(0.97); }
.pm-reset-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* 서비스 할당 */
.pm-service-badge {
  margin-left: 6px;
  padding: 2px 8px;
  background: #E3F2FD;
  color: #1565C0;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
}

.pm-service-badge.pm-shared {
  background: #F5F5F5;
  color: #757575;
}

.pm-service-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pm-service-label {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

.pm-service-select {
  flex: 1 1;
  padding: 6px 8px;
  border: 2px solid #E0E0E0;
  border-radius: 8px;
  font-size: 13px;
  background: #fff;
}

.pm-service-select:focus {
  border-color: #1565C0;
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PrinterManagePage.css"],"names":[],"mappings":"AAAA;;EAEE;;AAIF;EACE,cAAc;EACd,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kCAAkC,gBAAgB,EAAE;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;EAC1B,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,oBAAoB,WAAW,EAAE;;AAEjC;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,YAAY,cAAc,EAAE;;AAE5B;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,qCAAqC,0BAA0B,EAAE;AACjE,sCAAsC,0BAA0B,EAAE;AAClE,mCAAmC,0BAA0B,EAAE,mBAAmB,EAAE;;AAEpF;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,gBAAgB,gBAAgB,EAAE;AAClC,YAAY,WAAW,EAAE;;AAEzB;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,uBAAuB,sBAAsB,EAAE;AAC/C,yBAAyB,YAAY,EAAE,mBAAmB,EAAE;;AAE5D,WAAW;AACX;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf","sourcesContent":["/**\n * QR프린터관리 스타일 - 가로 태블릿용\n */\n\n@import url('https://fonts.googleapis.com/css2?family=Jua&family=Noto+Sans+KR:wght@400;500;700&display=swap');\n\n.pm-page {\n  height: 100dvh;\n  background: linear-gradient(135deg, #ECEFF1 0%, #CFD8DC 100%);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.pm-page button, .pm-page input { min-height: auto; }\n\n.pm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  background: rgba(255,255,255,0.85);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid rgba(0,0,0,0.06);\n  flex-shrink: 0;\n}\n\n.pm-header .btn-back {\n  background: none;\n  border: 2px solid #78909C;\n  color: #546E7A;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.pm-header .btn-back:active {\n  background: #ECEFF1;\n}\n\n.pm-header-center {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.pm-header h1 {\n  font-family: 'Jua', sans-serif;\n  font-size: 20px;\n  color: #37474F;\n  margin: 0;\n}\n\n.pm-header-spacer { width: 72px; }\n\n.pm-content {\n  flex: 1;\n  padding: 12px 16px;\n  overflow-y: auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  align-content: flex-start;\n}\n\n.pm-loading, .pm-error, .pm-empty {\n  width: 100%;\n  text-align: center;\n  padding: 40px;\n  font-size: 18px;\n  color: #666;\n}\n\n.pm-error { color: #C62828; }\n\n.pm-store-group {\n  width: 100%;\n}\n\n.pm-store-name {\n  font-family: 'Jua', sans-serif;\n  font-size: 18px;\n  color: #37474F;\n  margin: 0 0 8px;\n}\n\n.pm-printer-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.pm-printer-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 14px 16px;\n  width: calc(50% - 6px);\n  box-shadow: 0 2px 12px rgba(0,0,0,0.06);\n  border-left: 4px solid #2E7D32;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pm-printer-card.pm-status-warning { border-left-color: #F57C00; }\n.pm-printer-card.pm-status-critical { border-left-color: #C62828; }\n.pm-printer-card.pm-status-empty { border-left-color: #B71C1C; background: #FFF5F5; }\n\n.pm-printer-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.pm-printer-name {\n  font-family: 'Jua', sans-serif;\n  font-size: 16px;\n  color: #333;\n}\n\n.pm-disabled-badge {\n  margin-left: 6px;\n  padding: 2px 8px;\n  background: #EEE;\n  color: #999;\n  border-radius: 8px;\n  font-size: 11px;\n}\n\n.pm-printer-status {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.pm-paper-bar-container {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pm-paper-bar {\n  width: 100%;\n  height: 10px;\n  background: #E0E0E0;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.pm-paper-bar-fill {\n  height: 100%;\n  border-radius: 5px;\n  transition: width 0.5s ease;\n}\n\n.pm-paper-numbers {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n}\n\n.pm-remaining { font-weight: 700; }\n.pm-total { color: #999; }\n\n.pm-paper-detail {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #888;\n}\n\n.pm-reset-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.pm-reset-input {\n  width: 70px;\n  padding: 6px 8px;\n  border: 2px solid #E0E0E0;\n  border-radius: 8px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.pm-reset-input:focus {\n  border-color: #2E7D32;\n  outline: none;\n}\n\n.pm-reset-btn {\n  flex: 1;\n  padding: 8px 12px;\n  background: linear-gradient(135deg, #43A047, #2E7D32);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n\n.pm-reset-btn:active { transform: scale(0.97); }\n.pm-reset-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* 서비스 할당 */\n.pm-service-badge {\n  margin-left: 6px;\n  padding: 2px 8px;\n  background: #E3F2FD;\n  color: #1565C0;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.pm-service-badge.pm-shared {\n  background: #F5F5F5;\n  color: #757575;\n}\n\n.pm-service-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pm-service-label {\n  font-size: 12px;\n  color: #666;\n  white-space: nowrap;\n}\n\n.pm-service-select {\n  flex: 1;\n  padding: 6px 8px;\n  border: 2px solid #E0E0E0;\n  border-radius: 8px;\n  font-size: 13px;\n  background: #fff;\n}\n\n.pm-service-select:focus {\n  border-color: #1565C0;\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
